import { render, staticRenderFns } from "./examinationUpgrade.vue?vue&type=template&id=4431e72b&scoped=true"
import script from "./examinationUpgrade.vue?vue&type=script&lang=js"
export * from "./examinationUpgrade.vue?vue&type=script&lang=js"
import style0 from "./examinationUpgrade.vue?vue&type=style&index=0&id=4431e72b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431e72b",
  null
  
)

export default component.exports